/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActiveOrgIn,
  ChangePasswordIn,
  EmailChangeConfirmIn,
  EmailChangeIn,
  HTTPValidationError,
  MeOut,
  MessageResponse,
  MfaBackupCodesOut,
  MfaConfirmIn,
  MfaDisableIn,
  MfaStartOut,
  ProfileIn
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getMeResponse200 = {
  data: MeOut
  status: 200
}

export type getMeResponseSuccess = (getMeResponse200) & {
  headers: Headers;
};
;

export type getMeResponse = (getMeResponseSuccess)

export const getGetMeUrl = () => {




  return `/api/me`
}

/**
 * @summary Get Me
 */
export const getMe = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getMeResponse> => {

  return apiFetch<getMeResponse>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = unknown


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Me
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setActiveOrgResponse204 = {
  data: void
  status: 204
}

export type setActiveOrgResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setActiveOrgResponseSuccess = (setActiveOrgResponse204) & {
  headers: Headers;
};
export type setActiveOrgResponseError = (setActiveOrgResponse422) & {
  headers: Headers;
};

export type setActiveOrgResponse = (setActiveOrgResponseSuccess | setActiveOrgResponseError)

export const getSetActiveOrgUrl = () => {




  return `/api/me/active-org`
}

/**
 * @summary Set Active Org
 */
export const setActiveOrg = async (activeOrgIn: ActiveOrgIn, options?: Parameters<typeof apiFetch>[1]): Promise<setActiveOrgResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setActiveOrgResponse>(getSetActiveOrgUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(activeOrgIn)
  }
);}





export const getSetActiveOrgMutationKey = () => ['setActiveOrg'] as const;

export const getSetActiveOrgMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setActiveOrg>>, TError,SetActiveOrgMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setActiveOrg>>, TError,SetActiveOrgMutationVariables, TContext> => {

const mutationKey = getSetActiveOrgMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setActiveOrg>>, SetActiveOrgMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setActiveOrg(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetActiveOrgMutationResult = NonNullable<Awaited<ReturnType<typeof setActiveOrg>>>
    export type SetActiveOrgMutationBody = ActiveOrgIn
    export type SetActiveOrgMutationError = HTTPValidationError
    export type SetActiveOrgMutationVariables = {data: ActiveOrgIn}

    /**
 * @summary Set Active Org
 */
export const useSetActiveOrg = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setActiveOrg>>, TError,SetActiveOrgMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setActiveOrg>>,
        TError,
        SetActiveOrgMutationVariables,
        TContext
      > => {
      return useMutation(getSetActiveOrgMutationOptions(options), queryClient);
    }
    export type updateProfileResponse200 = {
  data: MeOut
  status: 200
}

export type updateProfileResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateProfileResponseSuccess = (updateProfileResponse200) & {
  headers: Headers;
};
export type updateProfileResponseError = (updateProfileResponse422) & {
  headers: Headers;
};

export type updateProfileResponse = (updateProfileResponseSuccess | updateProfileResponseError)

export const getUpdateProfileUrl = () => {




  return `/api/me/profile`
}

/**
 * @summary Update Profile
 */
export const updateProfile = async (profileIn: ProfileIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateProfileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateProfileResponse>(getUpdateProfileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(profileIn)
  }
);}





export const getUpdateProfileMutationKey = () => ['updateProfile'] as const;

export const getUpdateProfileMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,UpdateProfileMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,UpdateProfileMutationVariables, TContext> => {

const mutationKey = getUpdateProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfile>>, UpdateProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfile>>>
    export type UpdateProfileMutationBody = ProfileIn
    export type UpdateProfileMutationError = HTTPValidationError
    export type UpdateProfileMutationVariables = {data: ProfileIn}

    /**
 * @summary Update Profile
 */
export const useUpdateProfile = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfile>>, TError,UpdateProfileMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProfile>>,
        TError,
        UpdateProfileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProfileMutationOptions(options), queryClient);
    }
    export type requestEmailChangeResponse200 = {
  data: MessageResponse
  status: 200
}

export type requestEmailChangeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type requestEmailChangeResponseSuccess = (requestEmailChangeResponse200) & {
  headers: Headers;
};
export type requestEmailChangeResponseError = (requestEmailChangeResponse422) & {
  headers: Headers;
};

export type requestEmailChangeResponse = (requestEmailChangeResponseSuccess | requestEmailChangeResponseError)

export const getRequestEmailChangeUrl = () => {




  return `/api/me/email-change`
}

/**
 * The address changes only when the link sent to it is used, so nobody can take over an
 * address they don't control. Same answer whether or not it already has an account.
 * @summary Request Email Change
 */
export const requestEmailChange = async (emailChangeIn: EmailChangeIn, options?: Parameters<typeof apiFetch>[1]): Promise<requestEmailChangeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<requestEmailChangeResponse>(getRequestEmailChangeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(emailChangeIn)
  }
);}





export const getRequestEmailChangeMutationKey = () => ['requestEmailChange'] as const;

export const getRequestEmailChangeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmailChange>>, TError,RequestEmailChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestEmailChange>>, TError,RequestEmailChangeMutationVariables, TContext> => {

const mutationKey = getRequestEmailChangeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestEmailChange>>, RequestEmailChangeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestEmailChange(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof requestEmailChange>>>
    export type RequestEmailChangeMutationBody = EmailChangeIn
    export type RequestEmailChangeMutationError = HTTPValidationError
    export type RequestEmailChangeMutationVariables = {data: EmailChangeIn}

    /**
 * @summary Request Email Change
 */
export const useRequestEmailChange = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestEmailChange>>, TError,RequestEmailChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestEmailChange>>,
        TError,
        RequestEmailChangeMutationVariables,
        TContext
      > => {
      return useMutation(getRequestEmailChangeMutationOptions(options), queryClient);
    }
    export type confirmEmailChangeResponse200 = {
  data: MessageResponse
  status: 200
}

export type confirmEmailChangeResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type confirmEmailChangeResponseSuccess = (confirmEmailChangeResponse200) & {
  headers: Headers;
};
export type confirmEmailChangeResponseError = (confirmEmailChangeResponse422) & {
  headers: Headers;
};

export type confirmEmailChangeResponse = (confirmEmailChangeResponseSuccess | confirmEmailChangeResponseError)

export const getConfirmEmailChangeUrl = () => {




  return `/api/me/email-change/confirm`
}

/**
 * @summary Confirm Email Change
 */
export const confirmEmailChange = async (emailChangeConfirmIn: EmailChangeConfirmIn, options?: Parameters<typeof apiFetch>[1]): Promise<confirmEmailChangeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<confirmEmailChangeResponse>(getConfirmEmailChangeUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(emailChangeConfirmIn)
  }
);}





export const getConfirmEmailChangeMutationKey = () => ['confirmEmailChange'] as const;

export const getConfirmEmailChangeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmailChange>>, TError,ConfirmEmailChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmEmailChange>>, TError,ConfirmEmailChangeMutationVariables, TContext> => {

const mutationKey = getConfirmEmailChangeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmEmailChange>>, ConfirmEmailChangeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  confirmEmailChange(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof confirmEmailChange>>>
    export type ConfirmEmailChangeMutationBody = EmailChangeConfirmIn
    export type ConfirmEmailChangeMutationError = HTTPValidationError
    export type ConfirmEmailChangeMutationVariables = {data: EmailChangeConfirmIn}

    /**
 * @summary Confirm Email Change
 */
export const useConfirmEmailChange = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmEmailChange>>, TError,ConfirmEmailChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmEmailChange>>,
        TError,
        ConfirmEmailChangeMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmEmailChangeMutationOptions(options), queryClient);
    }
    export type changePasswordResponse200 = {
  data: MessageResponse
  status: 200
}

export type changePasswordResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type changePasswordResponseSuccess = (changePasswordResponse200) & {
  headers: Headers;
};
export type changePasswordResponseError = (changePasswordResponse422) & {
  headers: Headers;
};

export type changePasswordResponse = (changePasswordResponseSuccess | changePasswordResponseError)

export const getChangePasswordUrl = () => {




  return `/api/me/password`
}

/**
 * @summary Change Password
 */
export const changePassword = async (changePasswordIn: ChangePasswordIn, options?: Parameters<typeof apiFetch>[1]): Promise<changePasswordResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<changePasswordResponse>(getChangePasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(changePasswordIn)
  }
);}





export const getChangePasswordMutationKey = () => ['changePassword'] as const;

export const getChangePasswordMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,ChangePasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,ChangePasswordMutationVariables, TContext> => {

const mutationKey = getChangePasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, ChangePasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  changePassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = ChangePasswordIn
    export type ChangePasswordMutationError = HTTPValidationError
    export type ChangePasswordMutationVariables = {data: ChangePasswordIn}

    /**
 * @summary Change Password
 */
export const useChangePassword = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,ChangePasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        ChangePasswordMutationVariables,
        TContext
      > => {
      return useMutation(getChangePasswordMutationOptions(options), queryClient);
    }
    export type startMfaResponse200 = {
  data: MfaStartOut
  status: 200
}

export type startMfaResponseSuccess = (startMfaResponse200) & {
  headers: Headers;
};
;

export type startMfaResponse = (startMfaResponseSuccess)

export const getStartMfaUrl = () => {




  return `/api/me/mfa/start`
}

/**
 * @summary Start Mfa
 */
export const startMfa = async ( options?: Parameters<typeof apiFetch>[1]): Promise<startMfaResponse> => {

  return apiFetch<startMfaResponse>(getStartMfaUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStartMfaMutationKey = () => ['startMfa'] as const;

export const getStartMfaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMfa>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startMfa>>, TError,void, TContext> => {

const mutationKey = getStartMfaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startMfa>>, void> = () => {


          return  startMfa(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartMfaMutationResult = NonNullable<Awaited<ReturnType<typeof startMfa>>>

    export type StartMfaMutationError = unknown


    /**
 * @summary Start Mfa
 */
export const useStartMfa = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startMfa>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startMfa>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getStartMfaMutationOptions(options), queryClient);
    }
    export type confirmMfaResponse200 = {
  data: MfaBackupCodesOut
  status: 200
}

export type confirmMfaResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type confirmMfaResponseSuccess = (confirmMfaResponse200) & {
  headers: Headers;
};
export type confirmMfaResponseError = (confirmMfaResponse422) & {
  headers: Headers;
};

export type confirmMfaResponse = (confirmMfaResponseSuccess | confirmMfaResponseError)

export const getConfirmMfaUrl = () => {




  return `/api/me/mfa/confirm`
}

/**
 * @summary Confirm Mfa
 */
export const confirmMfa = async (mfaConfirmIn: MfaConfirmIn, options?: Parameters<typeof apiFetch>[1]): Promise<confirmMfaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<confirmMfaResponse>(getConfirmMfaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mfaConfirmIn)
  }
);}





export const getConfirmMfaMutationKey = () => ['confirmMfa'] as const;

export const getConfirmMfaMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmMfa>>, TError,ConfirmMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmMfa>>, TError,ConfirmMfaMutationVariables, TContext> => {

const mutationKey = getConfirmMfaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmMfa>>, ConfirmMfaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  confirmMfa(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmMfaMutationResult = NonNullable<Awaited<ReturnType<typeof confirmMfa>>>
    export type ConfirmMfaMutationBody = MfaConfirmIn
    export type ConfirmMfaMutationError = HTTPValidationError
    export type ConfirmMfaMutationVariables = {data: MfaConfirmIn}

    /**
 * @summary Confirm Mfa
 */
export const useConfirmMfa = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmMfa>>, TError,ConfirmMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmMfa>>,
        TError,
        ConfirmMfaMutationVariables,
        TContext
      > => {
      return useMutation(getConfirmMfaMutationOptions(options), queryClient);
    }
    export type disableMfaResponse204 = {
  data: void
  status: 204
}

export type disableMfaResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type disableMfaResponseSuccess = (disableMfaResponse204) & {
  headers: Headers;
};
export type disableMfaResponseError = (disableMfaResponse422) & {
  headers: Headers;
};

export type disableMfaResponse = (disableMfaResponseSuccess | disableMfaResponseError)

export const getDisableMfaUrl = () => {




  return `/api/me/mfa/disable`
}

/**
 * @summary Disable Mfa
 */
export const disableMfa = async (mfaDisableIn: MfaDisableIn, options?: Parameters<typeof apiFetch>[1]): Promise<disableMfaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<disableMfaResponse>(getDisableMfaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mfaDisableIn)
  }
);}





export const getDisableMfaMutationKey = () => ['disableMfa'] as const;

export const getDisableMfaMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableMfa>>, TError,DisableMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disableMfa>>, TError,DisableMfaMutationVariables, TContext> => {

const mutationKey = getDisableMfaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableMfa>>, DisableMfaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  disableMfa(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableMfaMutationResult = NonNullable<Awaited<ReturnType<typeof disableMfa>>>
    export type DisableMfaMutationBody = MfaDisableIn
    export type DisableMfaMutationError = HTTPValidationError
    export type DisableMfaMutationVariables = {data: MfaDisableIn}

    /**
 * @summary Disable Mfa
 */
export const useDisableMfa = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableMfa>>, TError,DisableMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableMfa>>,
        TError,
        DisableMfaMutationVariables,
        TContext
      > => {
      return useMutation(getDisableMfaMutationOptions(options), queryClient);
    }
